<template>
  <div :id="editorId" class="w-100 h-100"></div>
</template>

<script>
let unlayerLoader;

function loadUnlayer() {
  if (window.unlayer) {
    return Promise.resolve(window.unlayer);
  }
  if (!unlayerLoader) {
    unlayerLoader = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = `${window.location.origin}/unlayer/embed.js`;
      script.async = true;
      script.onload = () => resolve(window.unlayer);
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }
  return unlayerLoader;
}

export default {
  name: 'EmailEditor',
  props: {
    options: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['load', 'ready'],
  data() {
    return {
      editor: null,
      editorId: `gdq-email-editor-${Date.now()}`,
    };
  },
  mounted() {
    loadUnlayer().then(() => {
      const initOptions = {
        id: this.editorId,
        displayMode: 'email',
        ...this.options,
      };
      window.unlayer.init(initOptions);
      this.editor = window.unlayer;
      this.$emit('load');
      window.unlayer.addEventListener('editor:ready', () => {
        this.$emit('ready');
      });
    });
  },
  beforeUnmount() {
    if (this.editor && this.editor.destroy) {
      this.editor.destroy();
    }
  },
};
</script>
